import {useEffect, useRef, useState} from 'react';
import CssLoader from "../../components/CssLoader";
import Footer from "../../components/Footer";
import React from 'react';
import EventAccordion from "../../components/EventAccordion";

let json = require('../../data/erick.json');
let faq = `<h6 style="text-align: center">Program Ramadhan Islami Indosat</h6><div style="text-align: center">7 April 2021 – 24 Mei 2021</div><br/><b>Q:</b> Apa yang dimaksud dengan program layanan digital Islami?
<b>A:</b> Layanan multimedia berlangganan berisi konten-konten islami seperti kutipan tausiyah, nasihat islami, dan kutipan-kutipan ayat Al-Quran. Pelanggan juga akan mendapatkan bonus konten berupa foto dan video. Pelanggan yang baru saja berlangganan program ini akan memperoleh kesempatan untuk mendapatkan tambahan kuota 1GB

<b>Q:</b> Bagaimana cara mengikuti layanan ini?
<b>A:</b> Pelanggan Indosat dapat mengikuti program Islami ini dengan mengetik REG<spasi>ISLAMI kirim ke 99386. 

<b>Q:</b> Berapa tariff dari program ini?
<b>A:</b> Tarif dari program ini adalah Rp2000/3 hari.

<b>Q:</b> Kapan Program ini mulai berjalan?
<b>A:</b> Program ini berlangsung dari tanggal 7 April 2021 – 24 May 2021.

<b>Q:</b> 5.Bagaimana cara mendapatkan tambahan kuota 1GB?
<b>A:</b> Untuk mendapatkan tambahan kuota 1GB, pelanggan hanya perlu berlangganan ke program Islami. 

<b>Q:</b> Kapan tambahan kuota 1GB ini dikirimkan?
<b>A:</b> Jika menang, tambahan kuota 1GB ini akan dikirimkan maksimal H+7 dari akhir periode.

<b>Q:</b> Berapa pemenang program tambahan 1GB ini?
<b>A:</b> Pelanggan yang berhak mendapatkan tambahan kuota 1GB adalah 3000 pelanggan pertama yang berhasil berlangganan pada layanan Islami ini.

<b>Q:</b> Bagaimana jika pelanggan ingin mengetahui program ini lebih lanjut?
<b>A:</b> Pelanggan bisa menghubungi costumer service layanan ini di 021-52971540 atau email ke cs@triyakom.com`;

let sk = `<h6 style="text-align: center">Program Ramadhan Islami Indosat</h6><div style="text-align: center">7 April 2021 – 24 Mei 2021</div><br/>

Program Ramadhan Islami Indosat ini Berlaku bagi semua pelanggan kartu prabayar dan pascabayar IM3 Ooredoo. 

Layanan Islami mengadakan program Ramadhan dan membagikan tambahan 1GB untuk 3000 pelanggan pertama yang berlangganan layanan Islami di Indosat. 

Program tambahan 1GB ini berlaku dari periode 7 April 2021 – 24 Mei 2021. 

Untuk mendapatkan kuota data gratis sebesar 1GB, pelanggan diwajibkan untuk berlangganan pada layanan Islami di Indosat dengan mengetik sms REG&lt;spasi&gt;ISLAMI kirim ke 99386. 

Kuota yang didapat berlaku 30 hari sejak pelanggan menerima notifikasi

Pelanggan yang mendapatkan tambahan kuota 1GB tidak akan diumumkan, namun kuota akan dikirimkan maksimal H+7 setelah periode program berakhir. 

Paket data yang didapatkan pelanggan dapat digunakan di semua jaringan (2G/3G/4G) pada jam 00.00 s/d 23.59 

Paket data bersifat additional sehingga tidak mempengaruhi reguler data pelanggan

Paket data tidak dapat diakumulasikan 

Hadiah tidak dapat diuangkan. Kegagalan dalam melengkapi dokumen atau pemindahtanganan hadiah akan menggugurkan hadiah. Pemenang tidak dipungut biaya apapun selain biaya berlangganan layanan, seluruh biaya pajak dan administrasi ditanggung oleh pihak penyelenggara.

Hati-hati terhadap penipuan. Segala kerugian yang diakibatkan oleh tindak penipuan yang mengatasnamakan layanan Islami, PT. Triyakom, dan PT. Indosat Ooredoo diluar tanggung jawab pihak penyelenggara. Dengan bergabung di program Islami, maka kamu menyetujui seluruh syarat dan ketentuan yang berlaku. Untuk info lebih lanjut, hubungi Customer Service di 021-52971540 atau email ke cs@triyakom.com.`;


function LandingPageIslami() {
  
  const [skOpen, setSkOpen] = useState(false);
  const skRef = useRef();
  const openSk = ()=>{
    setSkOpen(true);
    setTimeout(() => {
      window.scrollTo(0, skRef.current.offsetTop - 400);
    }, 200);
  }
  
  return <>
    <CssLoader css={json.css}/>
    <div className="content event">
      <div className="event-img">
        <img src='https://app.triyakom.com/match_quiz/web/2021-03-24%20Banner%20Islami%20Isat%20%28Program%20Ramadhan%29.jpg'/>
      </div>
      <div className="container">
        <div className="event-text">
          <h5 style={{textAlign: 'center'}}>TAUSIYAH ISLAMI</h5>
          <p>Layanan multimedia berlangganan berisi konten-konten islami seperti kutipan tausiyah, nasihat islami, dan
            kutipan-kutipan ayat Al Qur'an. Pelanggan juga akan mendapatkan bonus konten berupa foto dan video. Dengan
            berlangganan layanan ini, pelanggan bisa mengakses konten-konten ISLAMI sepuasnya!</p>
          <p>Ada bonus 1GB juga loh untuk 3000 user pertama yang berlangganan!</p>
        </div>
        
        <div className="accordion-content">
          <div className="accordion">
            
            <EventAccordion skClick={openSk} title="FAQ" type="faq"
                            data={faq}/>
            
            <div ref={skRef}>
              <EventAccordion open={skOpen} title="Syarat &amp; Ketentuan"
                              data={sk}/>
            </div>
          
          
          </div>
        </div>
        <div>
        <a href={json.sms.im3} style={{
          padding: '1em 2em',
          color: '#FFF',
          borderRadius: '24px',
          textDecoration: 'none',
          margin: '2em',
          display: "block",
          fontStyle: 'normal',
          fontSize: '1.2em',
          textAlign: 'center',
          letterSpacing: '2px',
          border: 'none',
          boxShadow: '2px 2px 6px 0px rgb(0 0 0 / 45%)',
          backgroundColor: 'rgb(194,118,8)',
          lineHeight: 1,
          background: 'linear-gradient(rgb(191 111 12) 0%, rgb(154 109 7) 100%)',
          //backgroundColor: 'var(--bg-header)',
        }}>GABUNG</a>
      </div>
      </div>
    </div>
    
    <Footer/>
  </>
}

export default LandingPageIslami;